export function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}
export function escapeHtmlAttribute(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
export function moneyFormat(val, isMx = true) {
    try {
        if (isMx) {
            return (new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(val)) || val;
        }
        else {
            return (new Intl.NumberFormat("es-MX").format(val)) || val;
        }
    }
    catch (error) {
        return val;
    }
}
;
